module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-06-14c56dcdfce39632e226f723e22840ac.jpg";